import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      meta: { requiresAuth: true },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/dashboard",
          name: "dashboard",
          meta: {
            menuName: "Dashboard"
          },
          component: () => import("./views/dashboard/Index.vue")
        },
        // START REPORT
        {
          path: "/report/operation-dashboard",
          name: "Dashboard",
          meta: {
            menuName: "Dashboard"
          },
          component: () => import("./views/report/dashboard/Index.vue")
        },
        {
          path: "/report/location-status",
          name: "Location Status",
          meta: {
            menuName: "Location Status"
          },
          component: () => import("./views/report/locationstatus/Index.vue")
        },
        // END REPORT
        // START ROLE MANAGEMENT
        {
          path: "/menu",
          name: "menu",
          meta: {
            menuName: "Menu"
          },
          component: () => import("./views/rolemanagement/menu/Index.vue")
        },
        {
          path: "/menu/view",
          name: "menu-view",
          meta: {
            menuName: "Menu"
          },
          component: () => import("./views/rolemanagement/menu/ViewEdit.vue")
        },
        {
          path: "/menu/add",
          name: "menu-add",
          meta: {
            menuName: "Menu"
          },
          component: () => import("./views/rolemanagement/menu/Add.vue")
        },
        {
          path: "/usergroup",
          name: "usergroup",
          meta: {
            menuName: "User Group"
          },
          component: () => import("./views/rolemanagement/usergroup/Index.vue")
        },
        {
          path: "/groupaccess",
          name: "groupaccess",
          meta: {
            menuName: "User Group"
          },
          component: () =>
            import("./views/rolemanagement/groupaccess/Index.vue")
        },
        {
          path: "/user",
          name: "user",
          meta: {
            menuName: "Users"
          },
          component: () => import("./views/rolemanagement/user/Index.vue")
        },
        {
          path: "/user/view",
          name: "user-view",
          meta: {
            menuName: "Users"
          },
          component: () => import("./views/rolemanagement/user/ViewEdit.vue")
        },
        {
          path: "/user/add",
          name: "user-add",
          meta: {
            menuName: "Users"
          },
          component: () => import("./views/rolemanagement/user/Add.vue")
        },
        // END ROLE MANAGEMENT
        {
          path: "/inbound-delivery",
          name: "inbound-delivery",
          meta: {
            menuName: "Inbound Delivery"
          },
          component: () => import("./views/Inbound/InboundDelivery.vue")
        },
        {
          path: "/inbound-delivery/create",
          name: "inbound-delivery-create",
          meta: {
            menuName: "Inbound Delivery"
          },
          component: () => import("./views/Inbound/InboundDeliveryCreate.vue")
        },
        {
          path: "/inbound-delivery/view",
          name: "inbound-delivery-view",
          meta: {
            menuName: "Inbound Delivery"
          },
          component: () => import("./views/Inbound/InboundDeliveryViewEdit.vue")
        },
        {
          path: "/good-receive",
          name: "good-receive",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/GoodReceive.vue")
        },
        {
          path: "/good-receive/create",
          name: "good-receive-create",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/GoodReceiveCreate.vue")
        },
        {
          path: "/good-receive/view",
          name: "good-receive-view",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/GoodReceiveViewEdit.vue")
        },
        {
          path: "/good-receive/item-check",
          name: "item-check",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/ItemCheck.vue")
        },
        {
          path: "/good-receive/putaway-background",
          name: "putaway-background",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/PutAwayBackground.vue")
        },
        {
          path: "/good-receive/putaway-foreground",
          name: "putaway-foreground",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/PutAwayForeground.vue")
        },
        {
          path: "/good-receive/cancel",
          name: "cancel-gr",
          meta: {
            menuName: "Good Receiving"
          },
          component: () => import("./views/Inbound/CancelGoodReceive.vue")
        },

        {
          path: "/home",
          name: "home",
          component: () => import("./views/Home.vue")
        },
        {
          path: "/page2",
          name: "page-2",
          component: () => import("./views/Page2.vue")
        },
        // START OUTBOUND
        {
          path: "/outbound-delivery",
          name: "outbound-delivery",
          meta: {
            menuName: "Outbound Delivery"
          },
          component: () => import("./views/outbound/Index.vue")
        },
        {
          path: "/outbound-delivery/add",
          name: "outbound-add",
          meta: {
            menuName: "Outbound Delivery"
          },
          component: () => import("./views/outbound/Add.vue")
        },
        {
          path: "/outbound-delivery/view",
          name: "outbound-view",
          meta: {
            menuName: "Outbound Delivery"
          },
          component: () => import("./views/outbound/ViewEdit.vue")
        },
        // END OUTBOUND

        // START DO
        {
          path: "/delivery-order",
          name: "delivery-order",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/Index.vue")
        },
        {
          path: "/delivery-order/add",
          name: "delivery-order-add",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/Add.vue")
        },
        {
          path: "/delivery-order/view",
          name: "delivery-order-view",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/ViewEdit.vue")
        },
        {
          path: "/delivery-order/background",
          name: "delivery-order-background",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/Background.vue")
        },
        {
          path: "/delivery-order/foreground",
          name: "delivery-order-foreground",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/Foreground.vue")
        },
        {
            path: "/delivery-order/background-reverse",
            name: "delivery-order-background-reverse",
            meta: {
                menuName: "Delivery Order"
            },
            component: () => import("./views/deliveryorder/BackgroundReverse.vue")
        },
        {
            path: "/delivery-order/foreground-reverse",
            name: "delivery-order-foreground-reverse",
            meta: {
                menuName: "Delivery Order"
            },
            component: () => import("./views/deliveryorder/ForegroundReverse.vue")
        },
        {
          path: "/delivery-order/check",
          name: "delivery-order-check",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/Check.vue")
        },
        {
          path: "/delivery-order/pack",
          name: "delivery-order-pack",
          meta: {
            menuName: "Delivery Order"
          },
          component: () => import("./views/deliveryorder/Pack.vue")
        },
        {
          path: "/wave-pick-planning",
          name: "wave-pick-planning",
          meta: {
            menuName: "Wave Pick Planning"
          },
          component: () => import("./views/wavepickplanning/Index.vue")
        },
        {
          path: "/wave-pick-planning/add",
          name: "wave-pick-planning-add",
          meta: {
            menuName: "Wave Pick Planning"
          },
          component: () => import("./views/wavepickplanning/Add.vue")
        },
        {
          path: "/wave-pick-planning/view",
          name: "wave-pick-planning-view",
          meta: {
            menuName: "Wave Pick Planning"
          },
          component: () => import("./views/wavepickplanning/View.vue")
        },
        {
          path: "/wave-pick-planning/check",
          name: "wave-pick-planning-check",
          meta: {
            menuName: "Wave Pick Planning"
          },
          component: () => import("./views/wavepickplanning/Check.vue")
        },
        {
          path: "/pick-list",
          name: "pick-list",
          meta: {
            menuName: "Picking List"
          },
          component: () => import("./views/checking/Index.vue")
          // component: () => import("./views/picklist/Index.vue")
        },
        {
          path: "/pick-list/view",
          name: "pick-list-view",
          meta: {
            menuName: "Picking List"
          },
          component: () => import("./views/picklist/View.vue")
        },
        {
          path: "/pick-list/check",
          name: "pick-list-check",
          meta: {
            menuName: "Picking List"
          },
          component: () => import("./views/picklist/Check.vue")
        },
        {
          path: "/checking-packing",
          name: "checking-packing",
          meta: {
            menuName: "Checking & Packing"
          },
          component: () => import("./views/checking/Index.vue")
        },
        // END DO
        
        /** 
         * 
         * START RDO
         * 
         * **/
            {
            path: "/return-delivery-order",
            name: "return-delivery-order",
            meta: {
                menuName: "Return Delivery Order"
            },
            component: () => import("./views/returndeliveryorder/Index.vue")
            },
            {
            path: "/return-delivery-order/add",
            name: "return-delivery-order-add",
            meta: {
                menuName: "Return Delivery Order"
            },
            component: () => import("./views/returndeliveryorder/Add.vue")
            },
            {
            path: "/return-delivery-order/view",
            name: "return-delivery-order-view",
            meta: {
                menuName: "Return Delivery Order"
            },
            component: () => import("./views/returndeliveryorder/View.vue")
            },
            {
                path: "/return-delivery-order/check",
                name: "return-delivery-order-check",
                meta: {
                  menuName: "Return Delivery Order"
                },
                component: () => import("./views/returndeliveryorder/Check.vue")
            },
            {
                path: "/return-delivery-order/background",
                name: "return-delivery-order-background",
                meta: {
                  menuName: "Return Delivery Order"
                },
                component: () => import("./views/returndeliveryorder/Background.vue")
            },
            {
                path: "/return-delivery-order/foreground",
                name: "return-delivery-order-foreground",
                meta: {
                  menuName: "Return Delivery Order"
                },
                component: () => import("./views/returndeliveryorder/Foreground.vue")
            },
        /** 
         * 
         * END RDO
         * 
         * **/

        // START MASTER

        // {
        //   path: '/master/uom',
        //   name: 'master-uom',
        //   component: () => import('./views/Home.vue')
        // },
       
        {
          path: "/master/client",
          name: "master-client",
          meta: {
            menuName: "Client"
          },
          component: () => import("./views/master/client/Index.vue")
        },

      
        {
          path: "/master/warehouse",
          name: "master-warehouse",
          meta: {
            menuName: "Warehouses"
          },
          component: () => import("./views/master/warehouse/Index.vue")
        },

        {
          path: "/master/customer",
          name: "master-customer",
          meta: {
            menuName: "Customer"
          },
          component: () => import("./views/master/customer/Index.vue")
        },

        {
          path: "/master/customer/add",
          name: "master-customer-add",
          meta: {
            menuName: "Customer"
          },
          component: () => import("./views/master/customer/Add.vue")
        },

        {
          path: "/master/customer/view",
          name: "master-customer-view",
          meta: {
            menuName: "Customer"
          },
          component: () => import("./views/master/customer/ViewEdit.vue")
        },

        {
          path: "/master/product-category",
          name: "master-product-category",
          meta: {
            menuName: "Product Category"
          },
          component: () => import("./views/master/product-category/Index.vue")
        },
        {
          path: "/master/product-category-detail",
          name: "master-product-category-detail",
          meta: {
            menuName: "Product Cat. Detail"
          },
          component: () =>
            import("./views/master/product-category-detail/Index.vue")
        },

        {
          path: "/master/product",
          name: "master-product",
          meta: {
            menuName: "Products"
          },
          component: () => import("./views/master/products/Index.vue")
        },

        {
          path: "/master/products/add",
          name: "master-product-add",
          meta: {
            menuName: "Product"
          },
          component: () => import("./views/master/products/Add.vue")
        },

        {
          path: "/master/products/view",
          name: "master-product-view",
          meta: {
            menuName: "Product"
          },
          component: () => import("./views/master/products/ViewEdit.vue")
        },
        // START INVENTORIES
        {
          path: "/inventory",
          name: "inventory",
          meta: {
            menuName: "Inventory List"
          },
          component: () => import("./views/inventory/inventory/Index.vue")
        },

        // Movement Order
        {
          path: "/movement-order",
          name: "movement-order",
          meta: {
            menuName: "Movement Order"
          },
          component: () => import("./views/inventory/movement-order/Index.vue")
        },
        {
          path: "/movement-order/add",
          name: "movement-order-add",
          meta: {
            menuName: "Movement Order"
          },
          component: () => import("./views/inventory/movement-order/Add.vue")
        },
        {
          path: "/stock-check",
          name: "stock-check",
          meta: {
            menuName: "Inventory List"
          },
          component: () => import("./views/inventory/stock-check/Index.vue")
        },
        {
          path: "/stock-check/add",
          name: "stock-check-add",
          meta: {
            menuName: "Inventory List"
          },
          component: () => import("./views/inventory/stock-check/Add.vue")
        },
        {
          path: "/stock-check/view",
          name: "stock-check-view",
          meta: {
            menuName: "Inventory List"
          },
          component: () => import("./views/inventory/stock-check/View.vue")
        },
        {
          path: "/stock-check/count",
          name: "stock-check-count",
          meta: {
            menuName: "Inventory List"
          },
          component: () => import("./views/inventory/stock-check/Count.vue")
        },

        // Stock Transfer
        {
          path: "/stock-transfer",
          name: "stock-transfer",
          meta: {
            menuName: "Stock Transfer"
          },
          component: () => import("./views/inventory/stock-transfer/Index.vue")
        },
        {
          path: "/stock-transfer/add",
          name: "stock-transfer-add",
          meta: {
            menuName: "Stock Transfer"
          },
          component: () => import("./views/inventory/stock-transfer/Add.vue")
        },
        {
          path: "/stock-transfer/view",
          name: "stock-transfer-view",
          meta: {
            menuName: "Stock Transfer"
          },
          component: () => import("./views/inventory/stock-transfer/ViewEdit.vue")
        },
        {
          path: "/stock-transfer/put",
          name: "stock-transfer-put",
          meta: {
            menuName: "Stock Transfer"
          },
          component: () => import("./views/inventory/stock-transfer/Put.vue")
        },
        {
          path: "/stock-transfer/pick",
          name: "stock-transfer-pick",
          meta: {
            menuName: "Stock Transfer"
          },
          component: () => import("./views/inventory/stock-transfer/Pick.vue")
        },
        // Replenish
        {
          path: "/replenish",
          name: "replenish",
          meta: {
            menuName: "Replenish"
          },
          component: () => import("./views/inventory/replenish/Index.vue")
        },
        {
          path: "/replenish/add",
          name: "replenish-add",
          meta: {
            menuName: "Replenish"
          },
          component: () => import("./views/inventory/replenish/Add.vue")
        },
        {
            path: "/replenish/view",
            name: "replenish-view",
            meta: {
              menuName: "Replenish"
            },
            component: () => import("./views/inventory/replenish/View.vue")
          },
        // END INVENTORIES

        /* START VAS */
        {
            path: "/production-order",
            name: "production-order",
            meta: {
                menuName: "Production Order"
            },
            component: () => import("./views/valueaddedservice/productionorder/Index.vue")
        },
        {
            path: "/production-order/add",
            name: "production-order-add",
            meta: {
                menuName: "Production Order"
            },
            component: () => import("./views/valueaddedservice/productionorder/Add.vue")
        },
        {
            path: "/production-order/view",
            name: "production-order-view",
            meta: {
                menuName: "Production Order"
            },
            component: () => import("./views/valueaddedservice/productionorder/View.vue")
        },
        {
            path: "/production-order/pick-background",
            name: "production-order-pick-background",
            meta: {
                menuName: "Production Order"
            },
            component: () => import("./views/valueaddedservice/productionorder/PickBackground.vue")
        },
        {
            path: "/production-order/putaway-background",
            name: "production-order-putaway-background",
            meta: {
                menuName: "Production Order"
            },
            component: () => import("./views/valueaddedservice/productionorder/PutawayBackground.vue")
        },
        {
          path: "/transport/track-awb",
          name: "track-awb",
          meta: {
              menuName: "Track AWB"
          },
          component: () => import("./views/transport/Track.vue")
      },
      {
        path: "/change-password",
        name: "change-password",
        meta: {
            menuName: "Change Password"
        },
        component: () => import("./views/ChangePassword.vue")
    },

        /* END VAS */
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/auth",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue")
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
